import {LOADING, SET_CAMPAIGN,SET_CAMPAIGNS, SET_CAMPAIGNS_ASSIGMENTS} from './types'
export const setCampaign = (payload) => {
    return {
        type: SET_CAMPAIGN,
        payload: payload
    }
}
export const setCampaigns = (payload) => {
    return {
        type: SET_CAMPAIGNS,
        payload: payload
    }
}

export const setCampaignsAssigments = (payload) => {
    return {
        type: SET_CAMPAIGNS_ASSIGMENTS,
        payload: payload
    }
}

export const setLoadingCampaigns = (payload) => {
    return {
        type: LOADING,
        payload: payload
    }
}